// 앱 진입점입니다. 이 앱의 라우트와 provider 조립은 src/App.tsx 에 있습니다(docs/monorepo-migration.md).
import { bootstrap } from '@nenana/feature-shell/bootstrap';

bootstrap(() => import('./src/App'));
